(function(){
  /* Bij het openen is er nog geen doostype gekozen: kaart pas actief na een klik of na ?doos= in de link */
  var B=document.body;
  function schoon(){
    if(B.dataset.pdcType==='1') return;
    var td=document.getElementById('type_doos'); if(!td) return;
    [].forEach.call(td.querySelectorAll('.box_type_main.active'),function(k){ k.classList.remove('active'); });
  }
  function start(){
    var td=document.getElementById('type_doos'); if(!td) return;
    schoon();
    new MutationObserver(schoon).observe(td,{attributes:true,attributeFilter:['class'],subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
